(function () {
  'use strict';

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function drawer() {
    return document.getElementById('CartDrawer');
  }

  function cartRoute(name, fallback) {
    return window.theme && theme.routes && theme.routes[name]
      ? theme.routes[name]
      : fallback;
  }

  var addResetTimer;

  function mobileCartMotionEnabled() {
    return !window.matchMedia || window.matchMedia('(max-width: 768px)').matches;
  }

  function productAddButton(target) {
    var button = target && target.closest
      ? target.closest('[data-add-to-cart], [data-aspyr-preorder-submit]')
      : null;
    if (!button || button.disabled || !button.closest('.aspyr-product-section')) return null;
    return button;
  }

  function beginProductAdd(button) {
    if (!button || !mobileCartMotionEnabled()) return;
    var root = drawer();
    button.classList.remove('aspyr-cart-added');
    button.classList.add('aspyr-cart-submitting');
    if (root) {
      root.classList.remove('aspyr-cart-just-added');
      root.classList.add('aspyr-cart-is-adding');
    }

    // Open immediately with a subtle progress state instead of making the
    // customer wait on the network before receiving visual feedback.
    document.dispatchEvent(new CustomEvent('cart:open'));
    window.clearTimeout(addResetTimer);
    addResetTimer = window.setTimeout(function () {
      button.classList.remove('aspyr-cart-submitting');
      if (root) root.classList.remove('aspyr-cart-is-adding');
    }, 7000);
  }

  function completeProductAdd(event) {
    if (!mobileCartMotionEnabled()) return;
    var detail = event.detail || {};
    var button = detail.addToCartBtn || document.querySelector('.aspyr-product-section .aspyr-cart-submitting');
    var root = drawer();
    window.clearTimeout(addResetTimer);

    if (button) {
      button.classList.remove('aspyr-cart-submitting', 'aspyr-cart-pressing');
      button.classList.add('aspyr-cart-added');
      window.setTimeout(function () {
        button.classList.remove('aspyr-cart-added');
      }, 620);
    }

    if (root) {
      root.classList.remove('aspyr-cart-is-adding', 'aspyr-cart-just-added');
      void root.offsetWidth;
      root.classList.add('aspyr-cart-just-added');
      window.setTimeout(function () {
        root.classList.remove('aspyr-cart-just-added');
      }, 520);
    }
  }

  function cancelProductAdd() {
    if (!mobileCartMotionEnabled()) return;
    var root = drawer();
    document.querySelectorAll('.aspyr-product-section .aspyr-cart-submitting').forEach(function (button) {
      button.classList.remove('aspyr-cart-submitting', 'aspyr-cart-pressing');
    });
    if (root) root.classList.remove('aspyr-cart-is-adding');
  }

  function initNativeDrawer() {
    var root = drawer();
    if (!root || root.dataset.aspyrDrawerReady === 'true') return;
    if (!window.theme || !theme.CartDrawer) return;

    // The ASPYR header creates its own stacking context. Moving the drawer to
    // body keeps the announcement/header and backdrop behind the cart panel.
    if (root.parentNode !== document.body) {
      document.body.appendChild(root);
    }
    root.dataset.aspyrDrawerReady = 'true';
    window.aspyrNativeCartDrawer = window.aspyrNativeCartDrawer || new theme.CartDrawer();
  }

  function updateSummary(cart) {
    var root = drawer();
    if (!root || !cart) return;

    var count = root.querySelector('[data-aspyr-cart-count]');
    if (count) count.textContent = cart.item_count;

    syncProtection(cart);

    var threshold = Number(root.dataset.shippingThreshold || 0);
    if (!threshold) return;

    var remaining = Math.max(threshold - cart.total_price, 0);
    var percent = Math.min((cart.total_price / threshold) * 100, 100);
    var message = root.querySelector('[data-aspyr-shipping-message]');
    var total = root.querySelector('[data-aspyr-shipping-total]');
    var bar = root.querySelector('[data-aspyr-shipping-bar]');

    if (message) {
      message.innerHTML = remaining > 0
        ? 'Spend ' + money(remaining) + ' more and receive <strong>Free Shipping</strong>'
        : 'You unlocked <strong>Free Shipping</strong>';
    }
    if (total) total.textContent = money(cart.total_price);
    if (bar) bar.style.width = percent + '%';
  }

  function syncProtection(cart) {
    var root = drawer();
    var protection = root && root.querySelector('[data-aspyr-cart-protection]');
    if (!protection || !cart) return;

    var variantId = String(protection.dataset.variantId || '');
    var item = cart.items.find(function (cartItem) {
      return String(cartItem.variant_id) === variantId;
    });
    var toggle = protection.querySelector('[data-aspyr-protection-toggle]');
    var price = protection.querySelector('[data-aspyr-protection-price]');
    if (toggle) toggle.checked = Boolean(item);
    if (price && item) price.textContent = money(item.final_price || item.price);
  }

  function refreshCart(cart) {
    if (cart) updateSummary(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function updateProtection(toggle) {
    var protection = toggle.closest('[data-aspyr-cart-protection]');
    var variantId = String(protection.dataset.variantId || '');
    if (!variantId) return;

    // Capture the requested state before reading the cart. The cart read used
    // to synchronise this checkbox back to its old state before the add/remove
    // branch ran, which made an enabled switch immediately snap back off.
    var shouldEnable = toggle.checked;

    toggle.disabled = true;
    protection.classList.add('is-updating');
    getCart({ updateSummary: false })
      .then(function (cart) {
        var item = cart.items.find(function (cartItem) {
          return String(cartItem.variant_id) === variantId;
        });

        if (shouldEnable && !item) {
          return fetch(cartRoute('cartAdd', '/cart/add.js'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              properties: { '_ASPYR shipping protection': 'true' }
            })
          }).then(function (response) {
            if (!response.ok) return response.json().then(function (error) { throw error; });
            return getCart({ updateSummary: false });
          });
        }

        if (!shouldEnable && item) {
          return fetch(cartRoute('cartChange', '/cart/change.js'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          }).then(function (response) {
            if (!response.ok) return response.json().then(function (error) { throw error; });
            return response.json();
          });
        }

        return cart;
      })
      .then(refreshCart)
      .catch(function (error) {
        toggle.checked = !shouldEnable;
        window.alert(error.description || error.message || 'Shipping protection could not be updated.');
      })
      .finally(function () {
        toggle.disabled = false;
        protection.classList.remove('is-updating');
      });
  }

  function getCart(options) {
    options = options || {};
    return fetch(cartRoute('cart', '/cart.js'), { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (options.updateSummary !== false) updateSummary(cart);
        return cart;
      });
  }

  document.addEventListener('cart:updated', function (event) {
    updateSummary(event.detail && event.detail.cart);
  });

  document.addEventListener('pointerdown', function (event) {
    var button = productAddButton(event.target);
    if (!button) return;
    button.classList.add('aspyr-cart-pressing');
    window.setTimeout(function () {
      button.classList.remove('aspyr-cart-pressing');
    }, 180);
  });

  document.addEventListener('submit', function (event) {
    var button = event.target && event.target.querySelector
      ? event.target.querySelector('[data-add-to-cart]:not([disabled])')
      : null;
    if (button && button.closest('.aspyr-product-section')) beginProductAdd(button);
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-aspyr-preorder-submit]:not([disabled])');
    if (button && button.closest('.aspyr-product-section')) beginProductAdd(button);
  });

  document.addEventListener('ajaxProduct:added', function (event) {
    completeProductAdd(event);
    getCart();
  });
  document.addEventListener('ajaxProduct:error', cancelProductAdd);

  document.addEventListener('change', function (event) {
    var protectionToggle = event.target.closest('[data-aspyr-protection-toggle]');
    if (protectionToggle) {
      updateProtection(protectionToggle);
      return;
    }

    var select = event.target.closest('[data-aspyr-upsell-variant]');
    if (!select) return;
    var card = select.closest('[data-aspyr-upsell-card]');
    var option = select.options[select.selectedIndex];
    var button = card.querySelector('[data-aspyr-upsell-add]');
    var price = card.querySelector('[data-aspyr-upsell-price]');
    var compare = card.querySelector('[data-aspyr-upsell-compare]');
    button.dataset.variantId = select.value;
    if (price) price.textContent = money(Number(option.dataset.price || 0));
    if (compare) {
      var comparePrice = Number(option.dataset.comparePrice || 0);
      compare.textContent = comparePrice > Number(option.dataset.price || 0) ? money(comparePrice) : '';
    }
  });

  document.addEventListener('click', function (event) {
    var removeLink = event.target.closest('.aspyr-cart-drawer .cart__remove a');
    if (removeLink) {
      event.preventDefault();
      var item = removeLink.closest('[data-key]');
      if (!item) return;
      fetch(cartRoute('cartChange', '/cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: item.dataset.key, quantity: 0 })
      })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          updateSummary(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:build'));
        });
      return;
    }

    var button = event.target.closest('[data-aspyr-upsell-add]');
    if (!button) return;

    event.preventDefault();
    button.disabled = true;
    button.textContent = 'ADDING';

    var properties = {};
    if (button.dataset.preorder === 'true') {
      properties['_Preorder'] = 'true';
      properties['Pre-Order'] = 'ESTIMATED DELIVERY: 45–60 DAYS';
      properties['_Original product title'] = button.dataset.originalProductTitle || '';
      properties['_Original product URL'] = button.dataset.originalProductUrl || '';
    }

    fetch(cartRoute('cartAdd', '/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1, properties: properties }] })
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (error) { throw error; });
        return response.json();
      })
      .then(function (added) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: added } }));
      })
      .catch(function (error) {
        window.alert(error.description || error.message || 'This product could not be added to the cart.');
      })
      .finally(function () {
        button.disabled = false;
        button.textContent = 'ADD';
      });
  });

  initNativeDrawer();
  document.addEventListener('DOMContentLoaded', function () {
    initNativeDrawer();
    getCart();
  });
  document.addEventListener('shopify:section:load', function (event) {
    var replacement = event.target && event.target.querySelector && event.target.querySelector('#CartDrawer');
    if (replacement) {
      var existing = document.body.querySelector(':scope > #CartDrawer');
      if (existing && existing !== replacement) existing.remove();
    }
    initNativeDrawer();
    getCart();
  });
})();
